// Import stores
import AppStore from './AppStore';

// Combine stores
const store = {
  AppStore
};

export default store;
